module.exports = __webpack_public_path__ + "static/img/weather20.de07eb2f.png";